import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyLogistics from '../components/addEditCopyLogistics/index.vue';

var CopyLogisticsAgentPage = function (_super) {
  __extends(CopyLogisticsAgentPage, _super);

  function CopyLogisticsAgentPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyLogisticsAgentPage = __decorate([Component({
    components: {
      AddEditCopyLogistics: AddEditCopyLogistics
    }
  })], CopyLogisticsAgentPage);
  return CopyLogisticsAgentPage;
}(Vue);

export default CopyLogisticsAgentPage;